/**
 * A24-style product row paging.
 *
 * The A24 shop shows its featured-product rows as a Splide carousel that pages
 * ~4 cards at a time with ‹ › arrows. Dawn has no such component, so this is a
 * progressive-enhancement layer over the plain `.a24-row__track` flex-scroller:
 * without JS the track is still a normal horizontal scroll; with JS we add two
 * arrow buttons that scroll it by one "page" (the visible width) and disable
 * themselves at each end.
 */
(function () {
  'use strict';

  function enhance(row) {
    if (row.dataset.a24RowEnhanced) return;
    var track = row.querySelector('.a24-row__track');
    if (!track) return;
    row.dataset.a24RowEnhanced = '1';

    // A24 draws these as a tall, thin chevron (~19x44, 1px stroke), not a glyph
    var chevron =
      '<svg class="a24-row__arrow-svg" viewBox="0 0 20 46" fill="none" aria-hidden="true">' +
      '<polyline points="2,2 18,23 2,44" stroke="currentColor" stroke-width="1.4" ' +
      'stroke-linecap="square" stroke-linejoin="miter" vector-effect="non-scaling-stroke"/></svg>';

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'a24-row__arrow a24-row__arrow--prev';
    prev.setAttribute('aria-label', 'Previous');
    prev.innerHTML = chevron;

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'a24-row__arrow a24-row__arrow--next';
    next.setAttribute('aria-label', 'Next');
    next.innerHTML = chevron;

    function page() {
      // one card width, rounded, so a page lands on a card edge
      var item = track.querySelector('.a24-row__item');
      var step = item ? item.getBoundingClientRect().width : track.clientWidth;
      var perPage = Math.max(1, Math.floor(track.clientWidth / step));
      return step * perPage;
    }

    function sync() {
      // the track has horizontal padding + scroll-snap, so "at rest" scrollLeft
      // sits at ~paddingLeft rather than 0 — fold that into the end checks
      var padL = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      var maxScroll = track.scrollWidth - track.clientWidth - padL - 2;
      prev.disabled = track.scrollLeft <= padL + 2;
      next.disabled = track.scrollLeft >= maxScroll;
      // no point paging a row that already fits
      var fits = track.scrollWidth <= track.clientWidth + 1;
      row.classList.toggle('a24-row--enhanced', !fits);
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -page(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: page(), behavior: 'smooth' });
    });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });

    row.appendChild(prev);
    row.appendChild(next);
    sync();
    // images load late and grow the track — re-check shortly after
    setTimeout(sync, 400);
    window.addEventListener('load', sync, { once: true });
  }

  function run() {
    document.querySelectorAll('.a24-row').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
